
import { ENDPOINTS } from "utils/endpoints";
import { http } from "utils/http";





export const getGalleryBoard = (pageSize ,pageNum,size) => http({

    url: ENDPOINTS.Widget.GalleryBoard,
    method: 'get',
     params:{
        PageSize: pageSize  ,
        PageNumber:  pageNum,
        size
    }

}).then((res) => {
    return res.data
}).catch((err) => {
    return Promise.reject( err);
});


export const getDownloadUrlAttachmentAsync = (attachId ) => http({
    url: ENDPOINTS.Widget.bordUrl,
    method: 'get',
    params: {
        attachId: attachId
    },
    responseType:"blob"
}).then(response => {
    return response.data
}).catch((err) => {
  //   
    return Promise.reject( err);
});
